import { elk } from './libs/elk';
import { getUrlParam } from './url';


// 上报加载时间
function reportNavigationTiming() {
  const timing = window.performance.timing;
  const convertedTiming = {};

  // 将每个属性的时间戳转换为秒并存储在新的对象中
  convertedTiming.navigationStart = timing.navigationStart / 1000;
  convertedTiming.unloadEventStart = timing.unloadEventStart / 1000;
  convertedTiming.unloadEventEnd = timing.unloadEventEnd / 1000;
  convertedTiming.redirectStart = timing.redirectStart / 1000;
  convertedTiming.redirectEnd = timing.redirectEnd / 1000;
  convertedTiming.fetchStart = timing.fetchStart / 1000;
  convertedTiming.domainLookupStart = timing.domainLookupStart / 1000;
  convertedTiming.domainLookupEnd = timing.domainLookupEnd / 1000;
  convertedTiming.connectStart = timing.connectStart / 1000;
  convertedTiming.connectEnd = timing.connectEnd / 1000;
  convertedTiming.secureConnectionStart = timing.secureConnectionStart / 1000;
  convertedTiming.requestStart = timing.requestStart / 1000;
  convertedTiming.responseStart = timing.responseStart / 1000;
  convertedTiming.responseEnd = timing.responseEnd / 1000;
  convertedTiming.domLoading = timing.domLoading / 1000;
  convertedTiming.domInteractive = timing.domInteractive / 1000;
  convertedTiming.domContentLoadedEventStart = timing.domContentLoadedEventStart / 1000;
  convertedTiming.domContentLoadedEventEnd = timing.domContentLoadedEventEnd / 1000;
  convertedTiming.domComplete = timing.domComplete / 1000;
  convertedTiming.loadEventStart = timing.loadEventStart / 1000;
  convertedTiming.loadEventEnd = timing.loadEventEnd / 1000;

  const pageAllCost = performance.timing.domComplete - performance.timing.navigationStart
  const serverResCost = performance.timing.responseEnd - performance.timing.requestStart;
  const dnsCost = performance.timing.domainLookupEnd - performance.timing.domainLookupStart;
  const domHandleCost = performance.timing.domComplete - performance.timing.domLoading;
  const linkCost = performance.timing.requestStart - performance.timing.navigationStart;
  const tcpCost = performance.timing.connectEnd - performance.timing.connectStart;

  console.log('性能数据', convertedTiming);

  elk({
    key: 'NavigationTimingData',
    msg: '页面导航相关耗时',
    num1: pageAllCost, // 页面加载总耗时
    num2: serverResCost, // 服务器响应
    num3: dnsCost, // dns耗时
    num4: domHandleCost, // dom处理耗时
    num5: linkCost, // 建立连接耗时
    num6: tcpCost, // tcp时间
    str1: JSON.stringify(convertedTiming),
  });
}


function init() {
  if (typeof window.performance === "undefined") {
    console.warn("Performance API not supported in this browser.");
    return;
  }
  const testTag = getUrlParam('test');
  const isHitTest = +testTag === 1;

  if (!isHitTest) return;
  
  setTimeout(()=> {
    // 上报导航时间
    reportNavigationTiming();
  }, 6000)

}

init();
